// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"myName_wrapper__3m6lB","photo":"myName_photo__1y9Ub","name":"myName_name__1yRa5","description":"myName_description__aHlvC"};